// extracted by mini-css-extract-plugin
export default {"container":"GenericHeader_container__Z4Qkv"};